// Root Reducer combined with all Modules's Reducer.
import {combineReducers} from 'redux';
import TaxDocumentDataReducer from './taxDocument/reducer';
import PensionVerificationReducer from './pensionVerification/reducer';

const rootReducer = combineReducers({
    // Add your reducers here.
    taxDocuments: TaxDocumentDataReducer,
    pensionVerification: PensionVerificationReducer
});
const appReducer = (state, action) =>
  rootReducer(action.type === 'RESET_LOGOUT_FLAG' ? undefined : state, action);
  export default appReducer;